import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/55d8a1fb/src/components/layout.js";
import Layout from "../../../components/layout";
import { Link } from "gatsby";
import styled from "styled-components";
import { PrimaryButton } from "../../../components/Buttons";
import { SecondaryButton } from "../../../components/Buttons";
import '../form.css';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 className="rent-control-check-title">Hayward</h1>
    <p className="rent-control-check-description">Your property probably has rent-control if: (Enter the information regarding rent-control info for this city below...)</p>
    <ul className="cities">
  <li>Something here about what qualifies you are disqualifies you for rent-control</li>
  <li>Example of an exception:</li>
  <li>-- you live in a condo or single-family home.</li>
  {
        /* Add bullet points in these list item elements */
      }
  <li>...</li>
    </ul>
    <div className="rent-control-check-button-container">
      <PrimaryButton to="/coverage/overrides" mdxType="PrimaryButton">My city is not listed</PrimaryButton>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      